// extracted by mini-css-extract-plugin
export default {"loader":"preloader-bar_loader__8v-Sf","bar":"preloader-bar_bar__bJWBX","animate":"preloader-bar_animate__l5RWN"};